export default __webpack_public_path__ + "static/media/goopter-automate-ordering.30f70cbe.jpg";